import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Layout from './pages/Layout';

const Dashboard = lazy(() => import('./pages/Dashboard'));
const Newquote = lazy(() => import('./pages/NewQuote'));
const SavedQuotes = lazy(() => import('./pages/SavedQuotes'));
const ActiveQuote = lazy(() => import('./pages/ActiveQuote'));
const ApprovalQuotes = lazy(() => import('./pages/ApprovalQuotes'));
const HistoricalQuote = lazy(() => import('./pages/HistoricalQuote'));
const QuotePDF = lazy(() => import('./pages/QuotePDF'));
const TravelGenerator = lazy(() => import('./pages/TravelGenerator'));
const TravelPdfPreview = lazy(() => import('./pages/TravelPdfPreview'));
const UserManagement = lazy(() => import('./pages/UserManagement'));
const PartsManagement = lazy(() => import('./pages/PartsManagement'));
const CustomersData = lazy(() => import('./pages/CustomersData'));
const MenuAccess = lazy(() => import('./pages/MenuAccess'));
const QuoteDetails = lazy(() => import('./pages/QuoteDetails'));
const ReleaseToProduction = lazy(() => import('./pages/ReleaseToProduction'));
const Shipped = lazy(() => import('./pages/Shipped'));

function App() {
  return (
    <Router>
      <Suspense fallback={<div className="app-loading">Loading...</div>}>
        <Routes>
          <Route path="/" element={<Login />} />

          <Route element={<Layout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/newquote" element={<Newquote />} />
            <Route path="/newquote/:quoteId/:version" element={<Newquote />} />
            <Route path="/savedquotes" element={<SavedQuotes />} />
            <Route path="/quotedetails/:quoteId/:version" element={<QuoteDetails />} />
            <Route path="/activequote" element={<ActiveQuote />} />
            <Route path="/approvalquotes" element={<ApprovalQuotes />} />
            <Route path="/historicalquote" element={<HistoricalQuote />} />
            <Route path="/quote-pdf" element={<QuotePDF />} />
            <Route path="/travel-generator" element={<TravelGenerator />} />
            <Route path="/travel-pdf-preview" element={<TravelPdfPreview />} />
            <Route path="/user-management" element={<UserManagement />} />
            <Route path="/parts-management" element={<PartsManagement />} />
            <Route path="/customers" element={<CustomersData />} />
            <Route path="/menu-access" element={<MenuAccess />} />
            <Route path="/release-to-production" element={<ReleaseToProduction />} />
            <Route path="/shipped" element={<Shipped />} />
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
